import { CertificateCoreBase } from "./certificate.core.base"


export class CertificateCore extends CertificateCoreBase {

}